import type { ExtendedConstraints, CapabilityConfig } from '../../../types';
import * as AppletSpec from '../applet/applet';

export type Applet = AppletSpec.Applet;

export const id = 'config-applet';

export enum Events {}
export enum Actions {
  StateDirty = 'config-applet:state-dirty',
  StateReset = 'config-applet:state-reset',
}

export type Config = AppletSpec.Config & {
  type: typeof id;
};

export type ConfigObject = Record<string, unknown>;

export type Constraints = ExtendedConstraints<{
  events: Events;
  actions: Actions;
  config: Config;
  actionPayloadTuple: [Actions.StateDirty] | [Actions.StateReset];
}>;

export function isValidConfig(config: CapabilityConfig): boolean {
  if (!AppletSpec.isValidConfig(config)) {
    return false;
  }

  if (config.type !== id) {
    return false;
  }

  return true;
}
